<modal #modal>
    <div class="modal-header">
        <h5 class="modal-title">
            Køb afbrudt
        </h5>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()">
            
        </button>
    </div>
    <div class="modal-body">
        <p>Dit køb er afbrudt, ønsker du at fortryde?</p>

        <button type="button" class="btn btn-color-green" aria-label="Close" (click)="close()">
            Fortsæt køb
        </button>

        <button type="button" class="btn btn-color-green" aria-label="Close" (click)="onCancelClick()">
            Afslut og vis kvittering
        </button>

        <p>Oplever du problemer, så kontakt Kundeservice via vores chat, <a href="mailto:kundeservice@klasselotteriet.dk">e-mail</a> eller telefon: 3342 0900</p>
    </div>

    <div class="modal-footer">
        <app-opening-hours></app-opening-hours>
    </div>
</modal>
